import { ImagePlus, Loader2, MousePointerClick, ShieldCheck } from 'lucide-react';
import { useRef, useState } from 'react';
import { usePhoto } from '../context/PhotoContext';
import { useLanguage } from '../i18n';

export function UploadDropzone(): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null);
  const { loadFiles, isLoading } = usePhoto();
  const { t } = useLanguage();
  const [dragging, setDragging] = useState(false);

  return (
    <section
      className={`mx-auto flex min-h-[52vh] w-full max-w-4xl flex-col items-center justify-center rounded-xl border border-dashed px-6 py-12 text-center transition ${
        dragging ? 'border-[color:var(--accent)] bg-[color:var(--panel)]' : 'border-[color:var(--line)] bg-[color:var(--panel)]/52'
      }`}
      onDragOver={(event) => {
        event.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(event) => {
        event.preventDefault();
        setDragging(false);
        void loadFiles(event.dataTransfer.files);
      }}
    >
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-xl bg-[color:var(--text)] text-[color:var(--surface)]">
        {isLoading ? <Loader2 className="animate-spin" size={28} /> : <ImagePlus size={28} />}
      </div>
      <h1 className="text-3xl font-semibold tracking-normal sm:text-4xl">{t('home.dropTitle')}</h1>
      <p className="mt-4 max-w-xl text-sm leading-6 text-[color:var(--muted)]">
        {t('home.localBlurb')}
      </p>
      <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
        <button className="primary-button" onClick={() => inputRef.current?.click()}>
          <MousePointerClick size={16} />
          {t('home.select')}
        </button>
        <span className="inline-flex items-center gap-2 text-xs font-medium text-[color:var(--muted)]">
          <ShieldCheck size={15} />
          {t('home.localBadge')}
        </span>
      </div>
      <input
        ref={inputRef}
        type="file"
        className="sr-only"
        accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif"
        multiple
        onChange={(event) => {
          if (event.target.files) void loadFiles(event.target.files);
          event.currentTarget.value = '';
        }}
      />
    </section>
  );
}
